import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import "./styles/IngresosBodega.css";
import {
    ESTADOS_PALETIZACION,
    ESTADOS_PRODUCCION,
} from "../../../../../../../utility/constants";

class IngresosBodega extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "PENDIENTES_VALIDAR";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });

            sessionStorage.removeItem("prod_bod_pendientes_state");
            sessionStorage.removeItem("prod_bod_en_bodega_state");
            sessionStorage.removeItem("prod_bod_rechazados");
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        const { user } = this.props;

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "90vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent animated={false} />}
                    >
                        <TabPane
                            tab="Pendientes de validar"
                            key="PENDIENTES_VALIDAR"
                        >
                            <Listado
                                storageKey="prod_bod_pendientes_state"
                                estado={ESTADOS_PALETIZACION.PENDIENTE}
                                textoMetricas="Producción pendiente de validar"
                                recibidoBodegaMetricas={false}
                            />
                        </TabPane>
                        <TabPane tab="En bodega" key="EN_BODEGA">
                            <Listado
                                storageKey="prod_bod_en_bodega_state"
                                estado={[
                                    ESTADOS_PALETIZACION.ACEPTADO_PARCIAL,
                                    ESTADOS_PALETIZACION.ACEPTADO,
                                ]}
                                estadoMultiple={true}
                                textoMetricas="Producción validada"
                                recibidoBodegaMetricas={true}
                            />
                        </TabPane>
                        <TabPane tab="Rechazados" key="RECHAZADOS">
                            <Listado
                                storageKey="prod_bod_rechazados"
                                estado={ESTADOS_PALETIZACION.RECHAZADO}
                                textoMetricas="Producción rechazada"
                                recibidoBodegaMetricas={false}
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(IngresosBodega);
